import type { Store, JsonFilters } from '../../../store/list/types';
import { deselectAllRecordings } from './deselectAllRecordings';
import { startSearch } from './startSearch';

/**
 * The callback function supplied for the change attribute of the segment-bar directive.
 */
export const segmentChanged = (store: Store, jsonFilters: JsonFilters): void => {
  const { automatedFilterUpdateFlag, setAutomatedFilterUpdateFlag, setJsonFilters } =
    store.getState();

  setJsonFilters(jsonFilters);

  // -- This is nasty but I didn't find a way around it :(
  // On initial load, the backend controls the "days ago" filter based on the size of the result
  // set and returns the `effective_query` for whatever was returned. In this case, we need the
  // filters and segment bar to be updated, but don't want to re-initiate the search again -
  // therefore suppressing the API request.
  if (!automatedFilterUpdateFlag) {
    // We delay the search request here to give Angular time to update $scope.model.currentSegment
    // since we use the current segment ID to determine whether to fire "Segment Viewed" in the backend.
    startSearch(store);
    deselectAllRecordings(store);
  } else {
    // Reset the flag.
    setAutomatedFilterUpdateFlag(false);
  }
};
